<app-headerver></app-headerver>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-loading></app-loading>